const n=({headline:n,brand:e="",subBrand:o=""})=>n||[e,o].filter(Boolean).join(" ");export{n as getProductHeadline};
